import { Controller } from "stimulus"
import MitreTable from '../utils/mitre-table';

class TableImageSponsorRowController extends Controller {

  tableIdentifier = 'm-table';
  tableApiIdentifier = 't';

  initialize() {
    const tableKey = this.element.closest('[data-table-key-value]').getAttribute('data-table-key-value');
    this._mitreTable = MitreTable.getByTableKey(tableKey);
  }

  connect() {
    this._mitreTable.emit('table-sponsor-row-update-complete')
    console.log('TableImageSponsorRowController connected')
  }
}

export default TableImageSponsorRowController;
